import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MaterialCommunityIcons } from '../../utils/icons';
import './ChatScreen.css';

const ChatScreen: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="chat-container">
      <div className="chat-header">
        <button onClick={() => navigate('/')}>
          <MaterialCommunityIcons name="arrow-back" size={24} color="#FF006E" />
        </button>
        <h1>Chat</h1>
      </div>
      <div className="chat-content">
        <p>Chat functionality coming soon...</p>
      </div>
    </div>
  );
};

export default ChatScreen;

